import React from 'react'
import { Link } from 'react-router-dom'

function Order() {
  return (
    <div>
        
    <div className="breadcrumb-row">
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="d-flex justify-content-between align-items-center breadcrumb-item">
                            <div className="breadcrumb-title-heading">
                                <h1 className="title">Order List</h1>
                            </div>
                            <div className="breadcrumb-wrapper">
                                <span className="mr-1"><i className="ti ti-home"></i></span>
                                <Link title="Homepage" to="/">Home</Link>
                                <span className="ttm-bread-sep">&nbsp;/&nbsp;</span>
                                <span className="ttm-textcolor-skincolor">Order List</span>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>                    
        </div>
    
    {/* <!-- Section Start --> */}
    <section className="order-list">
        <div className="container-fluid">
            <div className="row">
                <div className="col-xl-3 col-lg-4">
                    <div className="account_sidebar style_2 section pb-0 h-100">
                        <h4 className="title">Filter</h4>
                        <ul>
                            <li className="active">
                                <Link to="#">
                                    Order Status
                                </Link>
                                <form action="#" method="POST">
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_os_1"/>
                                            <label className="custom-control-label" htmlFor="filter_os_1">On The Way</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_os_2"/>
                                            <label className="custom-control-label" htmlFor="filter_os_2">Delivered</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_os_3"/>
                                            <label className="custom-control-label" htmlFor="filter_os_3">Cancelled</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_os_4"/>
                                            <label className="custom-control-label" htmlFor="filter_os_4">Returned</label>
                                        </div>
                                    </div>
                                </form>
                            </li>
                            <li>
                                <Link to="#">
                                    Order Time
                                </Link>
                                <form action="#" method="POST">
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_ot_1"/>
                                            <label className="custom-control-label" htmlFor="filter_ot_1">Last 30 Days</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_ot_2"/>
                                            <label className="custom-control-label" htmlFor="filter_ot_2">2020</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_ot_3"/>
                                            <label className="custom-control-label" htmlFor="filter_ot_3">2019</label>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="custom-control custom-checkbox mr-sm-2">
                                            <input type="checkbox" className="custom-control-input" id="filter_ot_4"/>
                                            <label className="custom-control-label" htmlFor="filter_ot_4">Older</label>
                                        </div>
                                    </div>
                                </form>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-xl-9 col-lg-8">
                    <div className="order_list_box sidebar">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="input-group">
                                    <input type="text" name="#" className="form-control form-control-custom" placeholder="Search keywords..." autoComplete="off" required/>
                                    <div className="input-group-append">
                                        <button type="submit">
                                            <i className="fal fa-search"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="order_list_block">
                                    <div className="image_info_box">
                                        <Link to="/order-details">
                                            <img src="/tm/react/toolways/assets/images/product/grid/1.png" className="image-fit-contain" alt="img"/>
                                        </Link>
                                        <div className="info">
                                            <h6 className="mb-0 name"><Link to="/order-details">Power Drill</Link></h6>
                                            <p className="mb-0">1pc</p>
                                        </div>
                                    </div>
                                    <div className="price">$50</div>
                                    <div className="order_info">
                                        <h6 className="mb-0">Delivery on May 02</h6>
                                        <p className="mb-0">Your Item has been delivered</p>
                                        <span>
                                            <i className="fas fa-star"></i>
                                            Rate & Review Product
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="order_list_block">
                                    <div className="image_info_box">
                                        <Link to="/order-details">
                                            <img src="/tm/react/toolways/assets/images/product/grid/2.png" className="image-fit-contain" alt="img"/>
                                        </Link>
                                        <div className="info">
                                            <h6 className="mb-0 name"><Link to="/order-details">Battery Drill</Link></h6>
                                            <p className="mb-0">1pc</p>
                                        </div>
                                    </div>
                                    <div className="price">$50</div>
                                    <div className="order_info">
                                        <h6 className="mb-0">Delivery on May 02</h6>
                                        <p className="mb-0">Your Item has been delivered</p>
                                        <span>
                                            <i className="fas fa-star"></i>
                                            Rate & Review Product
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="order_list_block">
                                    <div className="image_info_box">
                                        <Link to="/order-details">
                                            <img src="/tm/react/toolways/assets/images/product/grid/3.png" className="image-fit-contain" alt="img"/>
                                        </Link>
                                        <div className="info">
                                            <h6 className="mb-0 name"><Link to="/order-details">Hammer Drill</Link></h6>
                                            <p className="mb-0">1pc</p>
                                        </div>
                                    </div>
                                    <div className="price">$50</div>
                                    <div className="order_info">
                                        <h6 className="mb-0">Delivery on May 02</h6>
                                        <p className="mb-0">Your Item has been delivered</p>
                                        <span>
                                            <i className="fas fa-star"></i>
                                            Rate & Review Product
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="order_list_block">
                                    <div className="image_info_box">
                                        <Link to="/order-details">
                                            <img src="/tm/react/toolways/assets/images/product/grid/4.png" className="image-fit-contain" alt="img"/>
                                        </Link>
                                        <div className="info">
                                            <h6 className="mb-0 name"><Link to="/order-details">Circular Grinder</Link></h6>
                                            <p className="mb-0">1pc</p>
                                        </div>
                                    </div>
                                    <div className="price">$50</div>
                                    <div className="order_info">
                                        <h6 className="mb-0">Delivery on May 02</h6>
                                        <p className="mb-0">Your Item has been delivered</p>
                                        <span>
                                            <i className="fas fa-star"></i>
                                            Rate & Review Product
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="order_list_block">
                                    <div className="image_info_box">
                                        <Link to="/order-details">
                                            <img src="/tm/react/toolways/assets/images/product/grid/5.png" className="image-fit-contain" alt="img"/>
                                        </Link>
                                        <div className="info">
                                            <h6 className="mb-0 name"><Link to="/order-details">Electrical Grinder</Link></h6>
                                            <p className="mb-0">1pc</p>
                                        </div>
                                    </div>
                                    <div className="price">$50</div>
                                    <div className="order_info">
                                        <h6 className="mb-0">Delivery on May 02</h6>
                                        <p className="mb-0">Your Item has been delivered</p>
                                        <span>
                                            <i className="fas fa-star"></i>
                                            Rate & Review Product
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="order_list_block">
                                    <div className="image_info_box">
                                        <Link to="/order-details">
                                            <img src="/tm/react/toolways/assets/images/product/grid/6.png" className="image-fit-contain" alt="img"/>
                                        </Link>
                                        <div className="info">
                                            <h6 className="mb-0 name"><Link to="/order-details">Battery Grinder</Link></h6>
                                            <p className="mb-0">1pc</p>
                                        </div>
                                    </div>
                                    <div className="price">$50</div>
                                    <div className="order_info">
                                        <h6 className="mb-0">Delivery on May 02</h6>
                                        <p className="mb-0">Your Item has been delivered</p>
                                        <span>
                                            <i className="fas fa-star"></i>
                                            Rate & Review Product
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <button type="button" className="thm-btn btn-rectangle thm-bg-color-one">Load More</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default Order